import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Store } from '@ngxs/store';
import { FlexLayoutType } from '../../constants/flex-layout.type';
import { SchedulerEventType } from '../../constants/scheduler-event.type';
import { StatusType } from '../../constants/status.type';
import { HearingRequestDetailsModel } from '../../models/hearing-request-details.model';
import { ScheduledEvent } from '../../models/scheduled-event';

@Component({
  selector: 'jsg-booking-summary-view',
  templateUrl: './booking-summary-view.component.html',
  styleUrls: ['./booking-summary-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingSummaryViewComponent {
  private _selectedSchedule: ScheduledEvent;
  get selectedEvent(): ScheduledEvent {
    return this._selectedSchedule;
  }
  @Input() set selectedEvent(value: ScheduledEvent) {
    this._selectedSchedule = value;
    if (value && value.start) {
      this.duration = (
        ((new Date(value.end).getTime() - new Date(value.start).getTime()) /
          36e5) *
        60
      ).toString();
    } else {
      this.duration = undefined;
    }
  }

  @Input() hearingRequest: HearingRequestDetailsModel;

  @Output()
  goToRequestClick: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  reserveTimeslot: EventEmitter<ScheduledEvent> = new EventEmitter<ScheduledEvent>();
  @Output()
  selectUrgentRequestDate: EventEmitter<ScheduledEvent> = new EventEmitter<ScheduledEvent>();
  @Output()
  returnToHearingRequest: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  returnToHearingDecision: EventEmitter<string> = new EventEmitter<string>();
  FlexLayoutType = FlexLayoutType;
  duration: string;

  SchedulerEventType = SchedulerEventType;

  constructor(private fb: FormBuilder, private store: Store) {}

  onGoToRequest = () => {
    if (this.selectedEvent && this.selectedEvent.actionNumber)
      this.goToRequestClick.emit(this.selectedEvent.actionNumber);
  };

  onReserveTimeslot = () => {
    if (!this.selectedEvent.hearingRequestId)
      this.reserveTimeslot.emit(this.selectedEvent);
  };

  onBookUrgentRequest = () => {
    if (this.selectedEvent?.eventType == SchedulerEventType.Urgent) {
      const bookingDetails: ScheduledEvent = {
        ...this.selectedEvent,
        duration: +this.duration,
      };
    }
  };

  onReturnToHearingRequest = () => {
    if (
      this.hearingRequest.isUrgent &&
      this.hearingRequest.hearingStatusCode == StatusType.Submitted
    )
      this.returnToHearingDecision.emit(this.hearingRequest.id);
    else this.returnToHearingRequest.emit(this.hearingRequest.id);
  };

  onSelectUrgentRequestDate = () => {
    const bookingDetails: ScheduledEvent = {
      ...this.selectedEvent,
      duration: +this.duration,
    };
    this.selectUrgentRequestDate.emit(bookingDetails);
  };
}
